var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.675 18.075C12.675 18.675 12.275 19.075 11.675 19.075C11.075 19.075 10.675 18.675 10.675 18.075C10.675 17.475 11.075 17.075 11.675 17.075C12.275 17.075 12.675 17.475 12.675 18.075ZM11.175 16.075H12.275L12.475 9.675H10.975L11.175 16.075ZM22.375 20.875L12.375 3.375C12.075 2.875 11.375 2.875 11.075 3.375L1.075 20.875C0.975 21.075 0.975 21.375 1.075 21.575C1.175 21.775 1.475 21.975 1.675 21.975H21.675C21.975 21.975 22.175 21.875 22.275 21.575C22.475 21.375 22.475 21.075 22.375 20.875ZM2.975 20.475L11.675 5.275L20.375 20.475H2.975Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningOutlined);
export default __webpack_public_path__ + "static/media/warning_outlined.023434c801d07a422b51d3119068337d.svg";
export { ForwardRef as ReactComponent };